import React from 'react';

const StockAlarmScreen = () => {
  return <>재고 알람 설정</>;
};

export default StockAlarmScreen;
